import React from 'react';
import { useTranslation } from 'react-i18next';
import { QBox, QFlex, QStack, QTag } from '@qualio/ui-components';
import { EventTag } from '../../../types/eventTag';
import { PropertySection } from './PropertySection';
import { PropertySectionText } from './PropertySectionText';

type Props = {
  tags: EventTag[];
};

const TagsSection: React.FC<Props> = ({ tags }) => {
  const { t } = useTranslation();
  return (
    <QStack>
      <PropertySection title={t('common.labels.tags')}>
        <QFlex flexWrap="wrap">
          {tags.length === 0 ? (
            <PropertySectionText>-</PropertySectionText>
          ) : (
            tags.map((tag) => (
              <QBox key={tag.id} mr={2} mb={2}>
                <QTag rightIcon={tag.group_ids?.length ? 'Lock' : undefined}>{tag.name}</QTag>
              </QBox>
            ))
          )}
        </QFlex>
      </PropertySection>
    </QStack>
  );
};

export default TagsSection;
